import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-sites-importer',
  templateUrl: './sites-importer.component.html',
  styleUrls: ['./sites-importer.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesImporterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
